import React from 'react';
import { subscriberBullets, subscriberStats } from '../../mock/content';
import { Check } from 'lucide-react';
import CountUp from './CountUp';
import Reveal from './Reveal';

const Subscriber = () => {
  return (
    <section id="grow-your-audience" className="bg-brand-soft py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4 text-center">
          Subscriber growth
        </p>
        <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px] text-center max-w-4xl mx-auto">
          Grow the audience you own — and get paid to do it
        </h2>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <p className="text-body-muted text-[16px] leading-[1.75]">
              This is the part publishers underestimate. Selling lead generation to your advertisers does not just add a revenue line: it adds subscribers, at zero acquisition cost, on somebody else's budget. Your clients get pipeline. You get a bigger, fresher first-party database every single month.
            </p>
            <ul className="mt-7 space-y-4">
              {subscriberBullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-gradient-to-br from-brand-blue to-brand-blue-light text-white flex items-center justify-center shrink-0 shadow-mk-blue">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  <span className="text-navy text-[15px] leading-[1.6] font-medium">{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-1 gap-5">
            {subscriberStats.map((s, i) => (
              <Reveal
                key={s.label}
                delay={i * 120}
                className="bg-white rounded-2xl shadow-mk p-7 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="text-brand-blue text-[38px] sm:text-[44px] font-black leading-none tracking-tight">
                  <CountUp value={s.value} />
                </div>
                <p className="mt-3 text-body-muted text-[15px] font-medium">{s.label}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscriber;
